module.exports = __webpack_public_path__ + "static/media/futureskill2.ef8b847a.png";